import React from "react";

import {
    WHEELCHAIR_ICON_PATH,
    WHEELCHAIR_ICON_VIEW_BOX,
} from "../../../image/icons/accessibility/wheelchairIcon.paths";
import {
    STOP_WHEELCHAIR_ICON_COLOR,
    STOP_WHEELCHAIR_STRIKE_COLOR,
    type StopWheelchairBoardingDisplay,
} from "./stopWheelchairBoarding.tools";

interface StopWheelchairBoardingIconProps {

    /** Whether the quai is accessible or explicitly not accessible. */
    "display": StopWheelchairBoardingDisplay;

    /** Optional CSS class for sizing in badges. */
    "className"?: string;
}

/**
 * Violet universal-access pictogram for quai labels.
 * When boarding is not accessible, a red diagonal strike is drawn over the icon.
 */
export const StopWheelchairBoardingIcon: React.FC<StopWheelchairBoardingIconProps> = ( {
    className = "h-4 w-4 flex-shrink-0",
    display,
} ) => {
    const ariaLabel = display === "accessible"
        ? "Accessible en fauteuil roulant"
        : "Non accessible en fauteuil roulant";

    return (
        <svg
            aria-label={ariaLabel}
            className={className}
            fill={STOP_WHEELCHAIR_ICON_COLOR}
            role="img"
            viewBox={WHEELCHAIR_ICON_VIEW_BOX}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d={WHEELCHAIR_ICON_PATH} />
            {display === "notAccessible"
                ? (
                    <line
                        stroke={STOP_WHEELCHAIR_STRIKE_COLOR}
                        strokeLinecap="round"
                        strokeWidth="1.75"
                        x1="1"
                        x2="15"
                        y1="15"
                        y2="1"
                    />
                )
                : null}
        </svg>
    );
};
